export default __webpack_public_path__ + "static/lexington-logo-d3e98effde0d92f58d33003ef7a36eaa.png";